/**
 * Cookie Consent Banner Component
 * GDPR/CCPA compliant cookie consent with opt-in for analytics/ads
 */

'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { initializeAnalytics } from '@/lib/analytics';

const COOKIE_CONSENT_KEY = 'cookie_consent';

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already responded to consent
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setShowBanner(true);
    } else {
      // Initialize analytics if consent was given
      const hasConsent = consent === 'accepted';
      initializeAnalytics(hasConsent);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    initializeAnalytics(true);
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    initializeAnalytics(false);
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t-2 border-primary-500 shadow-2xl animate-fade-in">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="font-semibold text-gray-900 mb-2">We value your privacy</h3>
            <p className="text-sm text-gray-600">
              We use cookies to enhance your experience, analyze site usage, and display relevant
              advertisements. You can manage your preferences at any time.{' '}
              <Link href="/legal/privacy" className="text-primary-500 hover:text-primary-600 underline">
                Learn more
              </Link>
            </p>
          </div>
          
          <div className="flex gap-3 w-full sm:w-auto">
            <button
              onClick={handleDecline}
              className="flex-1 sm:flex-none px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium"
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="flex-1 sm:flex-none px-6 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors font-medium"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

